
import React from 'react';

export const DriftMarks: React.FC = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-[2] opacity-0 animate-[fadeIn_2s_ease-in-out_forwards]">
      <svg
        viewBox="0 0 1000 1000"
        className="w-full h-full"
      >
        <path
          d="M 100,200 Q 150,150 300,250 T 600,200"
          stroke="black"
          strokeWidth="40"
          fill="none"
          strokeDasharray="10,20"
          className="drift-mark"
        />
        <path
          d="M 800,700 Q 750,850 600,750 T 300,800"
          stroke="black"
          strokeWidth="50"
          fill="none"
          strokeDasharray="5,15"
          className="drift-mark"
        />
      </svg>
    </div>
  );
};
